import { library } from '@fortawesome/fontawesome-svg-core'
import { faYoutube } from '@fortawesome/free-brands-svg-icons'
import {
  faSignalFair as faSignalFairDuo,
  faSignalGood as faSignalGoodDuo,
  faSignalPerfect as faSignalPerfectDuo,
  faSignalStrong as faSignalStrongDuo,
  faSignalWeak as faSignalWeakDuo,
} from '@fortawesome/pro-duotone-svg-icons'
import {
  faArrowUpRightFromSquare,
  faBars,
  faCalendar,
  faCalendarWeek,
  faCamcorder,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronsLeft,
  faChevronsRight,
  faCircleCheck,
  faCircleInfo,
  faCircleMinus,
  faCirclePlus,
  faClock,
  faClone,
  faCloudArrowUp,
  faCopy,
  faDownload,
  faEye,
  faEyeSlash,
  faFaceGlasses,
  faFaceGrinStars,
  faFaceSaluting,
  faFaceSmileBeam,
  faFaceSmileHearts,
  faFaceSmilingHands,
  faFaceSunglasses,
  faFaceThinking,
  faGears,
  faHeadset,
  faHouse,
  faImage,
  faLink,
  faLinkSlash,
  faListUl,
  faPenToSquare,
  faPlay,
  faVideo,
  faSearch,
  faStop,
  faSwatchbook,
  faTable,
  faTableList,
  faTrashCan,
  faTriangleExclamation,
  faUser,
  faWrench,
  faXmark,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faBatteryBolt as faBatteryBoltSolid,
  faBatteryEmpty as faBatteryEmptySolid,
  faBatteryFull as faBatteryFullSolid,
  faBatteryHalf as faBatteryHalfSolid,
  faBatterySlash as faBatterySlashSolid,
  faCircleCheck as faCircleCheckSolid,
  faCircleExclamation,
  faRotate as faRotateSolid,
  faTriangleExclamation as faTriangleExclamationSolid,
  faUser as faUserSolid,
} from '@fortawesome/pro-solid-svg-icons'

const IconLibrary = () => {
  library.add(
    faArrowUpRightFromSquare,
    faBars,
    faBatteryBoltSolid,
    faBatteryEmptySolid,
    faBatteryFullSolid,
    faBatteryHalfSolid,
    faBatterySlashSolid,
    faCalendar,
    faCalendarWeek,
    faCamcorder,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronsLeft,
    faChevronsRight,
    faCloudArrowUp,
    faCircleCheck,
    faCircleCheckSolid,
    faCircleExclamation,
    faCircleInfo,
    faCircleMinus,
    faCirclePlus,
    faClock,
    faClone,
    faCopy,
    faDownload,
    faTriangleExclamationSolid,
    faEye,
    faEyeSlash,
    faFaceGlasses,
    faFaceGrinStars,
    faFaceSaluting,
    faFaceSmileBeam,
    faFaceSmileHearts,
    faFaceSmilingHands,
    faFaceSunglasses,
    faFaceThinking,
    faGears,
    faHeadset,
    faHouse,
    faImage,
    faLink,
    faLinkSlash,
    faListUl,
    faPlay,
    faTable,
    faVideo,
    faPenToSquare,
    faRotateSolid,
    faSearch,
    faSignalFairDuo,
    faSignalGoodDuo,
    faSignalPerfectDuo,
    faSignalStrongDuo,
    faSignalWeakDuo,
    faStop,
    faSwatchbook,
    faTableList,
    faTrashCan,
    faTriangleExclamation,
    faUser,
    faUserSolid,
    faWrench,
    faXmark,
    faYoutube
  )
}

export default IconLibrary
